import { render } from "./investigator-investigations.html?vue&type=template&id=e32e5b1c&scoped=true&ts=true&external"
import script from "./investigator-investigations.ts?vue&type=script&lang=ts&external"
export * from "./investigator-investigations.ts?vue&type=script&lang=ts&external"

import "./investigator-investigations.scss?vue&type=style&index=0&id=e32e5b1c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e32e5b1c"]])

export default __exports__